<template>
  <div class="d-flex justify-between filters my-5">
    <div class="flex pr-5">
      <v-text-field
        label="Id"
        dense
        solo
        v-model="id"
        hide-details
        @change="$emit('update:id', $event)"
        append-icon="shopping_basket"
      >
      </v-text-field>
    </div>
    <div class="flex pr-5">
      <v-text-field
        label="Name"
        dense
        solo
        v-model="name"
        hide-details
        @change="$emit('update:name', $event)"
        append-icon="shopping_basket"
      >
      </v-text-field>
    </div>
    <div class="flex pr-5">
      <v-select
        :items="shipmentMethods"
        v-model="method"
        @change="$emit('update:method', $event)"
        label="Method"
        dense
        append-icon="tab"
        solo
        hide-details
      ></v-select>
    </div>
    <div class="flex pr-5">
      <v-select
        :items="actions"
        label="Batch Action"
        append-icon="more_vert"
        :disabled="!action"
        hide-details
        class="action_button"
        :menu-props="{ bottom: true, offsetY: true }"
        dense
        solo
      >
        <template v-slot:append-item>
          <v-divider></v-divider>
          <v-list class="py-0">
            <v-list-item-group>
              <v-list-item class="pointer">
                <v-list-item-content>
                  <v-list-item-title>
                    Delete
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-select>
    </div>
    <div>
      <v-btn block color="primary" @click="$emit('apply')">Apply filters</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    method: {
      type: String,
      default: null
    },
    action: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      actions: [],
      shipmentMethods: [
        { text: "All", value: null },
        { text: "Weight Based", value: "weight_based" },
        { text: "Price Based", value: "price_based" },
        { text: "Fixed Price", value: "fixed_price" }
      ]
    };
  }
};
</script>
